import { render, staticRenderFns } from "./babyMessage.vue?vue&type=template&id=58410d82&scoped=true&"
import script from "./babyMessage.vue?vue&type=script&lang=ts&"
export * from "./babyMessage.vue?vue&type=script&lang=ts&"
import style0 from "../less/index.less?vue&type=style&index=0&id=58410d82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58410d82",
  null
  
)

export default component.exports